import BaseStore from "Core/Stores/BaseStore";
import ViewStore from "Core/Stores/ViewStore";
import TranslationsStore from "Core/Stores/TranslationsStore";
import ModalsStore from "Core/Stores/ModalsStore";
import { decorate, computed, action } from "mobx";

class UIStore extends BaseStore {
  constructor(rootStore) {
    super(rootStore);

    this.translations = this.createTranslationsStore();
    this.view = this.createViewStore();
    this.modals = this.createModalsStore();
  }

  createTranslationsStore() {
    return new TranslationsStore(this.rootStore);
  }

  createViewStore() {
    return new ViewStore(this.rootStore);
  }

  createModalsStore() {
    return new ModalsStore(this.rootStore);
  }

  get translate() {
    return this.translations.translations;
  }

  get language() {
    return this.translations.language;
  }

  changeLanguage(language) {
    this.translations.language = language;
  }
}

decorate(UIStore, {
  translate: computed,
  language: computed,
  changeLanguage: action
});

export default UIStore;



// WEBPACK FOOTER //
// ./src/Core/Stores/UIStore/index.js